<template>
    <div class="online-layer">
        <div class="bg-01">
            <div class="top">
                <div class="logo"><img src="../../assets/images/zt/logo.png" alt=""></div>
                <div class="back"><a target="_blank" href="http://fmz.ourgame.com/"><img src="../../assets/images/zt/back.png" alt=""></a></div>
            </div>
        </div>
        <div class="bg-02">
            <div class="content flex-end">
                <div class="banner">
                    <img src="../../assets/images/zt/banner-font.png" alt="">
                </div>
            </div>
        </div>
        <div class="bg-03">
            <div class="title-pad">
                <div class="title1"></div>
            </div>
        </div>
        <div class="bg-04" id="anchor1">
            <div class="pic-list">
                <ul>
                    <li class="animate-pictrue" v-for="(item, index) in listData" :key="index">
                        <a target="_blank" :href="item.Url">
                            <img :src="item.ImgUrl" alt="">
                            <div class="discription">
                                <p>{{item.Summary}}</p>
                                <div class="btn">
                                    <a target="_blank" :href="item.Url">参与详情</a>
                                </div>
                            </div>
                            <div class="borders"></div>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
        <div class="bg-05" id="anchor2">
            <div class="content">
                <div class="titles"><img src="../../assets/images/zt/title1.png" alt=""></div>
                <div class="mp-layer flex-end mp-layer1">
                    <div class="left-font font1 display-n"><img src="../../assets/images/zt/pic2-1.png" alt=""></div>
                    <div class="role-pic pic1 display-n"><img src="../../assets/images/zt/pic2-2.png" alt=""></div>
                    <div class="right-dis1 dis1 display-n">
                        <ul>
                            <li class="li1">
                                <a href="#">
                                    <h4><img src="../../assets/images/zt/icon1.png" alt="">&nbsp;&nbsp;宗门故事</h4>
                                    <p>经受血海孕育出的强大战士，栖身幽冥与黑暗 为伴，没有任何人可以见到他们的真容！</p>
                                </a>
                            </li>
                            <li class="li2">
                                <a href="#">
                                    <h4><img src="../../assets/images/zt/icon1.png" alt="">&nbsp;&nbsp;宗门场景</h4>
                                    <p>幽冥血海，永夜之城，翻滚的岩浆。 貌如人工打造，实则全为自然生成。</p>
                                </a>
                            </li>
                            <li class="li3">
                                <a href="#">
                                    <h4><img src="../../assets/images/zt/icon1.png" alt="">&nbsp;&nbsp;宗门技能</h4>
                                    <p>血影持双刃，在战斗过程中，利用宗门秘 法隐匿身形于敌人身侧。
                                        一旦血影现身， 敌人势必需要承受如暴雨般的疯狂攻</p>
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="mp-layer flex-start mp-layer2">
                    <div class="right-dis1 dis2 display-n">
                        <ul>
                            <li class="li1">
                                <a href="#">
                                    <h4>宗门故事&nbsp;&nbsp;<img src="../../assets/images/zt/icon2.png" alt=""></h4>
                                    <p>经受几乎灭族之灾的上古遗民，魂幡可纳万物之灵是世人对这一族人唯一的了解。
                                        与九黎族人同行，时常可以听到幡中灵体的哭嚎，犹如地府恶域。</p>
                                </a>
                            </li>
                            <li class="li2">
                                <a href="#">
                                    <h4>宗门场景&nbsp;&nbsp;<img src="../../assets/images/zt/icon2.png" alt=""></h4>
                                    <p>九黎谷，与世隔绝的深山峡谷，天然的雾气使谷外修仙者无法近前，
                                        曾有金仙修士尝试入谷，最终仅元神得以脱困，落得修为尽毁的命运。</p>
                                </a>
                            </li>
                            <li class="li3">
                                <a href="#">
                                    <h4>宗门技能&nbsp;&nbsp;<img src="../../assets/images/zt/icon2.png" alt=""></h4>
                                    <p>战巫持魂幡，在战斗过程中，可唤出收纳于幡中的灵体为其作战。
                                        一名高阶修为的战巫可力战几名同阶修士不落下风。</p>
                                </a>
                            </li>
                        </ul>
                    </div>
                    <div class="left-font font2 display-n"><img src="../../assets/images/zt/pic1-1.png" alt=""></div>
                    <div class="role-pic pic2 display-n"><img src="../../assets/images/zt/pic1-2.png" alt=""></div>
                </div>
            </div>
        </div>
        <div class="bg-06">
            <div class="content">
                <div class="two">
                    <div class="part1" id="anchor3">
                        <div class="con">
                            <div class="pad">
                                <div class="com-title display-n" :class="fu6"><h3>万魔寨</h3></div>
                                <div class="com-content display-n" :class="fl6">
                                    <p>
                                        万魔寨所处之地灵气充盈，谷中灵兽、灵药生产颇丰
                                        然而，邪君梼杌与其魔族手下对所有入谷修士皆视如
                                        死敌，机缘与生存等待着众修士前往一探究竟……
                                    </p>
                                    <h4>副本掉落</h4>
                                    <ul>
                                        <li class="animate-pictrue">
                                            <a href="#"><img src="../../assets/images/zt/pic111.jpg" alt=""></a>
                                        </li>
                                        <li class="animate-pictrue">
                                            <a href="#"><img src="../../assets/images/zt/pic111.jpg" alt=""></a>
                                        </li>
                                        <li class="animate-pictrue">
                                            <a href="#"><img src="../../assets/images/zt/pic111.jpg" alt=""></a>
                                        </li>
                                    </ul>
                                    <div class="details-btn animate-pictrue">
                                        <a target="_blank" href="http://fmz.ourgame.com/contents/14/114.html">攻略详情</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="part2" id="anchor4">
                        <div class="con">
                            <div class="com-title display-n" :class="fu7"><h3>枭野争锋·决战天下</h3></div>
                            <div class="com-content display-n" :class="fi7">
                                <p>
                                    凡界各域纷争不断，修仙者、修魔者、修妖者各分派系传承，为了获取修炼资源，
                                    宗门间的明争暗斗不曾停息过……击败掠夺者，插入我方宗门旗帜，
                                    所在据点的收益皆归你所有。是屠尽异己，还是割据一脉，你会做
                                    出何种选择？！
                                </p>
                            </div>
                            <div class="display-n" :class="fi7">
                                <div class="two-pic">
                                    <a href="#"><img class="animate-pictrue" src="../../assets/images/zt/pic11.jpg" alt=""></a>
                                    <a href="#"><img class="animate-pictrue" src="../../assets/images/zt/pic12.jpg" alt=""></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="bg-07" id="anchor5">
            <!--选项卡-->
            <div class="tab-con">
                <el-tabs tab-position="left" style="height: 200px;">
                    <el-tab-pane>
                        <span slot="label">
                            <img src="../../assets/images/zt/font5.png" alt="">
                        </span>
                        <a href="#"><img class="animate-pictrue" src="../../assets/images/zt/tab2.jpg" alt=""></a>
                    </el-tab-pane>
                    <el-tab-pane>
                        <span slot="label">
                            <img src="../../assets/images/zt/font4.png" alt="">
                        </span>
                        <a href="#"><img class="animate-pictrue" src="../../assets/images/zt/tab1.jpg" alt=""></a>
                    </el-tab-pane>
                    <el-tab-pane>
                        <span slot="label">
                            <img src="../../assets/images/zt/font3.png" alt="">
                        </span>
                        <a href="#"><img class="animate-pictrue" src="../../assets/images/zt/tab3.jpg" alt=""></a>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <!--选项卡 end-->
            <div class="ewm-con">
                <div class="btns">
                    <a class="animate-pictrue download" target="_blank" href="http://fmz.ourgame.com/contents/22/26.html"></a>
                    <a class="animate-pictrue website" target="_blank" href="http://fmz.ourgame.com/"></a>
                </div>
                <div class="ewm">
                    <ul>
                        <li>
                            <img src="../../assets/images/zt/ewm-q.png" alt="">
                            <p>官方QQ1群</p>
                        </li>
                        <li>
                            <img src="../../assets/images/zt/ewm.png" alt="">
                            <p>官方公众号</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="bg-08" id="anchor6">
            <div class="content">
                <footer>
                    <p>积极健康的游戏心态是健康游戏的开端，本游戏故事情节设置紧凑，请您合理控制游戏时间，避免沉溺游戏影响生活，注意自我保护，防范网络陷阱。<br>
网络文化经营许可证　京网文[2018]5376-415号 软著登字第1387887号 新广出审【2016】881号<br>
网络游戏出版物号ISBN 978-7-89988-744-8 沪新出科数【2016】301号 网站备案号: <a target="_blank" href="https://beian.miit.gov.cn/">京ICP备09074391号-2</a>
                    </p>
                </footer>
            </div>
        </div>
        <div class="pop-layer" v-show="isPop">
            <ul>
                <li v-for="(item, index) in activeArray" :key="item.id" @click="handleLink(item.id)">
                    <a href="javascript:void(0)" :class="isActive == item.id? item.class:''"></a>
                </li>
                <li><a target="_blank" href="http://id.ourgame.com/regist.do?third_company=fumozhuan"></a></li>
                <li><a target="_blank" href="http://fmz.ourgame.com/contents/22/26.html"></a></li>
            </ul>
        </div>
    </div>
</template>
<script>
import $ from 'jquery'
import api from '../../api/api'
import activityList from '../../api/activityList.json'
let one;
let two;
let three;
let four;
let five;
let six;
export default {
    data() {
        return {
            listData: [],
            isPop: false,
            active1: '',
            active2: '',
            active3: '',
            active4: '',
            active5: '',
            isActive: '',
            activeArray: [{
                id: 1,
                class: 'active1'
            },{
                id: 2,
                class: 'active2'
            },{
                id: 3,
                class: 'active3'
            },{
                id: 4,
                class: 'active4'
            },{
                id: 5,
                class: 'active5'
            }],
            // {string} part6效果
            fu6: '',
            fl6: '',
            fu7: '',
            fi7: '',
        }
    },
    mounted() {
        window.addEventListener('scroll',this.getScrollPosite);
        $(".banner").addClass("animated fadeInDown display-b");
        // 获取列表
        this.getListData();
    },
    methods: {
        /**
         * 获取list
         */
        getListData() {
            let data = {};
            // 本地json文件list
            // this.listData = activityList;
            // 服务器json文件list
            api.getActivityList(data).then(res=>{
                this.listData = res.data;
            }).catch(res=>{})
        },
        /**
         * 滚动条事件
         */
        getScrollPosite() {
            var aa = $(this).scrollTop()
            let windowH = document.body.clientHeight;
            let docSrollTop = $(document).scrollTop(); //文档卷动值
            let clientH = $(window).height(); //视窗大小
            // let sectionTop = $(".part-one").offset().top; //动态文字模块距离文档头部的距离
            let sectionH = $(".mp-layer").offset().top;
            if(docSrollTop > 400){
                $(".banner").removeClass("animated fadeInDown display-b");
            } else {
                $(".banner").addClass("animated fadeInDown display-b");
            }
            if(docSrollTop > 2300 && docSrollTop < 3500){
                // 开始动画
                $(".font1").addClass("animated fadeInLeft display-b");
                $(".pic1").addClass("animated bounceInDown display-b");
                $(".dis1").addClass("animated fadeInRight display-b");
            } else {
                $(".font1").removeClass("animated fadeInLeft display-b");
                $(".pic1").removeClass("animated bounceInDown display-b");
                $(".dis1").removeClass("animated fadeInRight display-b");
            }
            if(docSrollTop > 2900 && docSrollTop < 4000){
                // 开始动画
                $(".font2").addClass("animated fadeInRight display-b");
                $(".pic2").addClass("animated bounceInUp display-b");
                $(".dis2").addClass("animated fadeInLeft display-b");
            } else {
                $(".font2").removeClass("animated fadeInRight display-b");
                $(".pic2").removeClass("animated bounceInUp display-b");
                $(".dis2").removeClass("animated fadeInLeft display-b");
            }
            // part1
            one = this.$el.querySelector('#anchor1').offsetTop;
            two = this.$el.querySelector('#anchor2').offsetTop;
            three = this.$el.querySelector('#anchor3').offsetTop;
            four = this.$el.querySelector('#anchor4').offsetTop;
            five = this.$el.querySelector('#anchor5').offsetTop;
            six = this.$el.querySelector('#anchor6').offsetTop-500;
            if(docSrollTop > three-500 && docSrollTop < four-500){
                this.fu6 = 'animated fadeInUp display-b';
                this.fl6 = 'animated fadeInLeft display-b';
            } else {
                this.fu6 = '';
                this.fl6 = '';
            }
            if(docSrollTop > four-500 && docSrollTop < five-300){
                this.fu7 = 'animated fadeInUp display-b';
                this.fi7 = 'animated fadeIn display-b';
            } else {
                this.fu7 = '';
                this.fi7 = '';
            }
            if(docSrollTop > 360){
                this.isPop = true;
            } else {
                this.isPop = false;
            }
            if(docSrollTop > one-400 && docSrollTop < two-200) {
                this.isActive = 1;
            } else if(docSrollTop > two-200 && docSrollTop < three-200) {
                this.isActive = 2;
            } else if(docSrollTop > three-200 && docSrollTop < four-100) {
                this.isActive = 3;
            } else if(docSrollTop > four-100 && docSrollTop < five-200) {
                this.isActive = 4;
            } else if(docSrollTop > five-200 && docSrollTop < six) {
                this.isActive = 5;
            }
        },
        /**
         * 悬浮导航点击事件
         */
        handleLink(id) {
            if(id == 1) {
                $('html,body').animate({scrollTop: one}, 600);
                // $(document).scrollTop(one);
            } else if(id == 2) {
                $('html,body').animate({scrollTop: two},600);
            } else if(id == 3) {
                $('html,body').animate({scrollTop: three},600);
            } else if(id == 4) {
                $('html,body').animate({scrollTop: four},600);
            } else if(id == 5) {
                $('html,body').animate({scrollTop: five},600);
            }
        }
    },
    components: {
    }
}
</script>
<style lang="scss">
.online-layer{
    .el-tabs{
        position: relative;
        height: 533px !important;

        .el-tabs__nav{
            height: 100%;
        }
        .el-tabs__header{
            position: absolute;
            z-index: 5;
            left: 0;
            top: 0;
            width: 220px;
        }
        .el-tabs__item.is-active{
            background-color: rgba($color: $color-yellow, $alpha: 1);
        }
        .el-tabs__active-bar{
            background-color: #f7e849;
        }
        .el-tabs__item{
            height: 33.333%;
            background-color: rgba($color: $color-yellow, $alpha: .6);
            border-bottom: 1px solid rgba(255, 255, 255, 0.6);

            span{
                height: 100%;
                @include flex-align-center();
            }
        }
        .el-tabs__item:nth-last-child(1){
            border-bottom: none;
        }
    }
}
</style>
<style lang="scss" scoped>
.online-layer{
    padding: 0;
    .bg-01{
        background:url(../../assets/images/zt/bg-01.jpg) center top no-repeat;
        height: 194px;
        .top{
            position: fixed;
            z-index: 9;
            @include flex-space-between();
            background-color: $color-brown;
            width: 100%;
            padding: 10px 0;
        }
    }
    .bg-02{
        background:url(../../assets/images/zt/bg-02.jpg) center top no-repeat;
        height: 657px;
        .banner{
            width: 328px;
            height: 657px;
        }
    }
    .bg-03{
        background:url(../../assets/images/zt/bg-03.jpg) center top no-repeat;
        height: 468px;
        .title-pad{
            padding-top: 290px;
        }
        .title1{
            margin: 0 auto;
            background:url(../../assets/images/zt/title2.png) center top no-repeat;
            width: 1200px;
            height: 154px;
        }
    }
    .bg-04{
        background:url(../../assets/images/zt/bg-04.jpg) center top no-repeat;
        height: 1656px;

        .pic-list{
            width: 960px;
            margin: 0 auto;

            ul{
                @include flex-space-between();
                @include flex-wrap-wrap();
                li{
                    position: relative;
                    margin: 10px 0;
                    width: 434px;
                    height: 297px;

                    .borders{
                        position: absolute;
                        z-index: 6;
                        width: 434px;
                        height: 297px;
                        background:url(../../assets/images/zt/border.png) center top no-repeat;
                        pointer-events: none;
                    }
                    img{
                        position: absolute;
                        z-index: 4;
                        width: 434px;
                        height: 297px;
                    }
                    .discription{
                        position: absolute;
                        z-index: 5;
                        bottom: 0;
                        width: 100%;
                        height: 100px;
                        background-color: rgba($color: $black, $alpha: .49);
                        @include flex-space-between();
                        @include flex-align-center();

                        p{
                            @include text-ellipsis-row();
                            padding: 0 20px;
                            line-height: 18px;
                            color: $color-white;
                            font-size: 12px;
                        }
                        .btn{
                            padding: 0 20px 0 0;
                            a{
                                border-radius: 6px;
                                text-align: center;
                                background-color: $color-yellow3;
                                width: 70px;
                                height: 26px;
                                line-height: 26px;
                                font-size: 12px;
                                color: $color-white;
                                display: block;
                            }
                            a:hover{
                                background-color: rgba($color: $color-yellow3, $alpha: .49);
                            }
                        }
                    }
                }
            }
        }
    }
    .bg-05{
        background:url(../../assets/images/zt/bg-05.jpg) center top no-repeat;
        height: 1140px;
        .mp-layer{
            position: relative;
            height: 648px;
            overflow: hidden;

            .left-font{
                position: absolute;
                z-index: 0;
            }
            .role-pic{
                position: absolute;
                z-index: 2;
                pointer-events: none;
            }
            .right-dis1{
                position: absolute;
                z-index: 1;
                top: 25%;
                width: 500px;

                ul{
                    li{
                        margin-bottom: 6px;
                        width: 100%;
                        @include flex-align-center();
                        a{
                            color: $color-white;
                            h4{
                                font-size: 14px;
                            }
                            p{
                                font-size: 12px;
                            }
                        }
                    }
                    li:hover{
                        -webkit-transition: all 0.4s ease-in-out;
                        -moz-transition: all 0.4s ease-in-out;
                        -ms-transition: all 0.4s ease-in-out;
                        -o-transition: all 0.4s ease-in-out;
                        transition: all 0.4s ease-in-out;
                    }
                }
            }
        }
        .mp-layer1{
            top: -50px;
            .left-font{
                left: 11%;
            }
            .role-pic{
                right: 25%;
            }
            .right-dis1{
                right: 3%;

                ul{
                    li{
                        margin-bottom: 6px;
                        width: 100%;
                        height: 86px;
                        @include flex-end();
                        a{
                            h4{
                                text-align: right;
                                color: $color-yellow2;
                            }
                        }
                    }
                    li:hover{
                        -webkit-transition: all 0.6s ease-in-out;
                        -moz-transition: all 0.6s ease-in-out;
                        -ms-transition: all 0.6s ease-in-out;
                        -o-transition: all 0.6s ease-in-out;
                        transition: all 0.6s ease-in-out;
                    }
                    .li1{
                        background:url(../../assets/images/zt/pic2-2-1.png) right top no-repeat;
                        margin-left: 0;
                        a{
                            padding-right: 18%;
                            width: 47%;
                        }
                    }
                    .li1:hover,.li2:hover,.li3:hover{
                        margin-left: 30px;
                    }
                    .li2{
                        background:url(../../assets/images/zt/pic2-2-2.png) right top no-repeat;
                        a{
                            padding-right: 18%;
                            width: 46%;
                        }
                    }
                    .li3{
                        background:url(../../assets/images/zt/pic2-2-3.png) right top no-repeat;
                        a{
                            padding-right: 18%;
                            width: 46%;
                        }
                    }
                }
            }
        }
        .mp-layer2{
            top: -250px;
            .left-font{
                right: 11%;
            }
            .role-pic{
                left: 30%;
            }
            .right-dis1{
                left: 3%;

                ul{
                    li{
                        margin-bottom: 6px;
                        width: 100%;
                        height: 94px;
                        @include flex-start();
                        a{
                            h4{
                                text-align: left;
                                color: $color-blue5;
                            }
                        }
                    }
                    .li1{
                        background:url(../../assets/images/zt/pic1-2-1.png) left top no-repeat;
                        margin-left: 0;
                        a{
                            padding-left: 19%;
                            width: 55%;
                        }
                    }
                    .li1:hover,.li2:hover,.li3:hover{
                        margin-left: -30px;
                    }
                    .li2{
                        background:url(../../assets/images/zt/pic1-2-2.png) left top no-repeat;
                        a{
                            padding-left: 19%;
                            width: 52%;
                        }
                    }
                    .li3{
                        background:url(../../assets/images/zt/pic1-2-3.png) left top no-repeat;
                        a{
                            padding-left: 19%;
                            width: 52%;
                        }
                    }
                }
            }
        }
    }
    .bg-06{
        background:url(../../assets/images/zt/bg-06.jpg) center top no-repeat;
        height: 1416px;
        
        .two{
            color: $color-white;
            .com-title{
                @include sprite-icons();
                width: 300px;
                height: 44px;
                margin-bottom: 30px;
                padding: 22px 0 0 70px;

                h3{
                    line-height: 40px;
                    font-size: 18px;
                }
            }
            .com-content{
                width: 300px;
                p{
                    padding-bottom: 20px;
                    line-height: 18px;
                    font-size: 14px;
                    background:url(../../assets/images/zt/borders.png) left bottom no-repeat;
                }
                h4{
                    line-height: 40px;
                    font-size: 16px;
                }
                ul{
                    @include flex-start();
                    li{
                        margin-right: 10px;
                        @include sprite-icons();
                        @include flex-center();
                        background-position: 0 -198px;
                        width: 45px;
                        height: 45px;
                        a{
                            width: 40px;
                            height: 40px;
                            img{
                                border-radius: 50%;
                                width: 40px;
                                height: 40px;
                            }
                        }
                    }
                }
                .details-btn{
                    margin: 20px 0 0 0;
                    @include sprite-icons();
                    background-position: 0 -263px;
                    width: 140px;
                    height: 36px;
                    line-height: 36px;
                    text-align: center;
                    a{
                        display: block;
                        color: $color-white;
                    }
                    a:hover{
                        color: $color-yellow1;
                    }
                }
            }
            .part1{
                background:url(../../assets/images/zt/pic6-1.jpg) center top no-repeat;
                height: 595px;
                
                .com-title{
                    background-position: -292px -66px;
                }
                .pad{
                    padding: 74px 0 0 113px;
                    .title-one{
                        width: 222px;
                        height: 60px;
                        background-position: -300px 0;
                    }
                }
            }
            .part2{
                padding-top: 29px;
                background:url(../../assets/images/zt/pic6-2.jpg) center top no-repeat;
                height: 729px;
                
                .com-title{
                    background-position: -292px 0;
                }
            }
            .two-pic{
                padding-top: 40px;
                @include flex-space-between();
            }
        }
    }
    .bg-07{
        background:url(../../assets/images/zt/bg-07.jpg) center top no-repeat;
        height: 1090px;
        .tab-con{
            padding-top: 180px;
            width: 903px;
            height: 533px;
            margin: 0 auto;
        }
        .ewm-con{
            padding-top: 110px;
            width: 800px;
            margin: 0 auto;
            @include flex-space-between();

            .btns{
                padding-top: 10px;
                width: 256px;

                a{
                    margin-bottom: 10px;
                    display: block;
                    height: 83px;
                    @include sprite-icons();
                }
                .download{
                    background-position: 0 0;
                }
                .website{
                    background-position: 0 -89px;
                }
            }
            .ewm{
                ul{
                    @include flex-start();
                    li{
                        margin-right: 20px;
                        p{
                            color: $color-white;
                            text-align: center;
                        }
                    }
                }
            }
        }
    }
    .bg-08{
        background:url(../../assets/images/zt/bg-08.jpg) center top no-repeat;
        height: 208px;
        footer{
            padding: 30px 100px;
            p{
                font-size: 12px;
                color: #b3aea5;
                text-align: center;
                line-height: 26px;
            }
            a{
                color: $color-yellow;
            }
        }
    }
    .titles{
        padding: 0;
    }
    .pop-layer{
        position: fixed;
        z-index: 9;
        top: 20%;
        right: 0;
        background:url(../../assets/images/zt/pop-bg1.png) center top no-repeat;
        width: 178px;
        height: 398px;

        ul{
            padding: 40px 29px;
            li{
                height: 30px;
                margin-top: 5px;
                a{
                    height: 30px;
                    display: block;
                }
                .active1{
                    @include sprite-icons();
                    background-position: 0 -360px;
                }
                .active2{
                    @include sprite-icons();
                    background-position: 0 -395px;
                }
                .active3{
                    @include sprite-icons();
                    background-position: 0 -431px;
                }
                .active4{
                    @include sprite-icons();
                    background-position: 0 -465px;
                }
                .active5{
                    @include sprite-icons();
                    background-position: 0 -500px;
                }
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/views/special/Online.vue